import Vue from 'vue';

import VBlackerTheme, { VBlackerThemeProvider } from 'v-blacker-theme';

import KernelStatusBadge from '@components/KernelStatusBadge.vue';
import KernelChartWrapper from '@components/KernelChartWrapper.vue';

import { createRouter } from '@router';

import store from '@store';

import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(VBlackerTheme);

Vue.component('kernel-status-badge', KernelStatusBadge);
Vue.component('kernel-chart-wrapper', KernelChartWrapper);

const router = createRouter();

const app = new Vue({
  store,
  router,
  ...VBlackerThemeProvider,
  render: (h) => h(App),
});

router.onReady(() => app.$mount('#app'));
